import DatasetSessionsComponent from "@/components/v1/SessionsComponent";

export default {
    "dataset-add-user-component": DatasetSessionsComponent
};



window.version = window.version || []
window.version['dataset'] = "1.1.0.0"